// Phase 25 sliding doors/windows: X = moving, O = fixed (mirrors backend sketches.COMMON / _slide_dirs).
export const COMMON = {
  2: ["XO", "OX", "XX"], 3: ["XOX", "OXO", "XXO", "OXX", "XXX"], 4: ["OXXO", "XXXX", "OXXX", "XXXO", "XOOX", "XXOO", "OOXX"],
  5: ["OXXXO", "XOXOX", "OXOXO", "XXXXX"], 6: ["OXXXXO", "XXXXXX", "XXOOXX", "OXOOXO"],
};
export const NO_MOVING = "At least one panel must move";
export const allFixed = (cfg) => !!cfg && !cfg.includes("X");

// Default direction: toward the nearest fixed panel, else toward the centre ("L"/"R" per X, "-" per O).
export function autoDirs(cfg) {
  const os = [...cfg].map((c, i) => (c === "O" ? i : -1)).filter((i) => i >= 0), mid = (cfg.length - 1) / 2;
  return [...cfg].map((c, i) => {
    if (c !== "X") return "-";
    const t = os.length ? os.reduce((b, o) => (Math.abs(o - i) < Math.abs(b - i) ? o : b), os[0]) : i !== mid ? mid : i + 1;
    return t > i ? "R" : "L";
  }).join("");
}

export const dirsOf = (cfg, dirs) => {
  const auto = autoDirs(cfg);
  if (!dirs || dirs.length !== cfg.length) return auto;
  return [...cfg].map((c, i) => (c !== "X" ? "-" : "LR".includes(dirs[i]) ? dirs[i] : auto[i])).join("");
};

export const togglePanel = (cfg, dirs, i) => {
  const next = [...cfg].map((c, k) => (k === i ? (c === "X" ? "O" : "X") : c)).join("");
  const d = [...dirsOf(cfg, dirs)];
  d[i] = next[i] === "X" ? autoDirs(next)[i] : "-";
  return { config: next, slide_dirs: d.join("") };
};

export const flipDir = (cfg, dirs, i) => {
  const d = [...dirsOf(cfg, dirs)];
  d[i] = d[i] === "L" ? "R" : "L";
  return { config: cfg, slide_dirs: d.join("") };
};

// The track for n panels (Two/Three/Four-Track…), keeping the High/Low style (mirrors backend components.track_for).
const WORDS = { 2: "Two", 3: "Three", 4: "Four", 5: "Five", 6: "Six" };
export function trackNote(row) {
  const n = (row.config || "").length, tracks = row.component?.line?.tracks || [];
  if (!tracks.length || n < 2 || tracks.some((t) => t.name.startsWith(`${WORDS[n]}-Track`))) return "";
  return `No ${WORDS[n].toLowerCase()}-track option for this product: priced on ${row.track || tracks[0].name}`;
}
export function trackFor(tracks, current, n) {
  const word = { 2: "Two", 3: "Three", 4: "Four", 5: "Five", 6: "Six" }[n];
  const names = (tracks || []).map((t) => t.name).filter((x) => word && x.startsWith(`${word}-Track`));
  const style = (current || "").match(/\(.*?\)/)?.[0];
  return names.find((x) => style && x.includes(style) && x.includes("Tile") === (current || "").includes("Tile")) || names.find((x) => !x.includes("Tile")) || current;
}
